'use strict';

var propTypes = require('./prop-types.js');
var invalidParameterError = require('./invalid-parameter-error.js');
require('@babel/runtime/helpers/defineProperty');
require('prop-types/factoryWithTypeCheckers');
require('./constants.js');
require('@babel/runtime/helpers/classCallCheck');
require('@babel/runtime/helpers/inherits');
require('@babel/runtime/helpers/possibleConstructorReturn');
require('@babel/runtime/helpers/getPrototypeOf');
require('@babel/runtime/helpers/wrapNativeSuper');

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */
/**
 * Helper to throw an error when no parameters are sent in a function.
 *
 * @function
 * @param {string} parameterName - The name of the parameter sent.
 * @returns {void}
 * @example
 * const myFunction = (param1 = requiredParameter('param1')) => {};
 * myFunction();
 * // => InvalidParameterError: Required parameter, param1 is missing.
 */

var requiredParameter = function requiredParameter() {
  var parameterName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var requiredParameterErrorText = 'Required parameter';

  if (parameterName) {
    requiredParameterErrorText = "".concat(requiredParameterErrorText, ", ").concat(parameterName, " is missing.");
  }

  var requiredParameterError = new invalidParameterError(requiredParameterErrorText); // Preserve original stack trace (only for V8)

  if (invalidParameterError.captureStackTrace && invalidParameterError.captureStackTrace.constructor === Function) {
    invalidParameterError.captureStackTrace(requiredParameterError, requiredParameter);
  }

  throw requiredParameterError;
};

requiredParameter.HELPER_ID = 'Gearz.JsUtils.requiredParameter';
requiredParameter.returnType = undefined;
requiredParameter.parameterTypes = {
  parameterName: propTypes.stringWithDescription('The name of the paramenter.')
};
requiredParameter.defaultParameters = {
  parameterName: ''
};

module.exports = requiredParameter;
